var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('new-atout-popup', {
    attrs: {
      "data-to-show": _vm.isNewAtoutPopupDisplayed,
      "limit": _vm.hasLimit ? 22 : null
    },
    on: {
      "close": function ($event) {
        return _vm.changeStateNewAtoutPopup(false);
      },
      "addAtout": function (newValue) {
        _vm.addNewAtout(newValue);
      }
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "my-15"
  }, [_vm._v("Valeurs personnelles")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "mx-10"
  }, [_vm.isErrorMaxLengthDisplayed ? _c('div', {
    staticClass: "text-pink-600 text-base text-center mb-8"
  }, [_vm._v("\n            Le nombre de valeurs maximal a été atteint pour ce type de CV\n        ")]) : _vm._e(), _vm._v(" "), _vm.isErrorMinLengthDisplayed ? _c('div', {
    staticClass: "text-pink-600 text-base text-center mb-8"
  }, [_vm._v("\n            Afin d'avoir un rendu visuel optimal, il faut sélectionner entre 3 et 5 valeurs\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "relative w-max"
  }, [_c('add-button', {
    staticClass: "mb-8",
    attrs: {
      "libelle": "Ajouter une nouvelle valeur"
    },
    on: {
      "add": function ($event) {
        return _vm.changeStateNewAtoutPopup(true);
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-3 gap-3"
  }, _vm._l(_vm.defaultAtouts, function (dAtout, kda) {
    return _c('div', {
      key: 'default' + kda,
      staticClass: "col-span-full md:col-span-1"
    }, [_c('tag', {
      staticClass: "cursor-pointer",
      attrs: {
        "theme-color": (((_vm.form.data.atouts || {}).value || {}).default || []).includes(dAtout) ? 'indigo-2' : 'white',
        "libelle": dAtout,
        "text-size": "text-sm",
        "text-font": "font-light",
        "icon": (((_vm.form.data.atouts || {}).value || {}).default || [])[kda] === dAtout ? 'minus-circle' : 'plus-circle',
        "icon-color": (((_vm.form.data.atouts || {}).value || {}).default || [])[kda] === dAtout ? 'text-indigo-600' : 'text-gray-600',
        "icon-size": "w-4 h-4",
        "can-truncate": true,
        "scale-on-hover": true
      },
      on: {
        "push": function ($event) {
          return _vm.displayDefaultAtout(dAtout);
        }
      }
    })], 1);
  }), 0), _vm._v(" "), _c('hr', {
    staticClass: "my-5"
  }), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-3 gap-3"
  }, _vm._l(_vm.persoAtouts, function (pAtout, kpa) {
    return _c('div', {
      key: 'perso' + kpa,
      staticClass: "col-span-1"
    }, [_c('tag', {
      staticClass: "cursor-pointer",
      attrs: {
        "theme-color": pAtout.isDisplayed ? 'indigo-2' : 'white',
        "libelle": pAtout.value,
        "text-size": "text-sm",
        "text-font": "font-light",
        "icon": pAtout.isDisplayed ? 'minus-circle' : 'plus-circle',
        "icon-color": pAtout.isDisplayed ? 'text-indigo-600' : 'text-gray-600',
        "icon-size": "w-4 h-4",
        "can-truncate": true,
        "scale-on-hover": true
      },
      on: {
        "push": function ($event) {
          return _vm.displayPersoAtout(kpa);
        }
      }
    })], 1);
  }), 0)])], 1);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mx-10 text-xs mb-10 text-justify"
  }, [_c('p', [_vm._v("Les valeurs personnelles sont les convictions que nous considérons comme particulièrement importantes pour nous, celles qui constituent nos repères essentiels et qui nous servent à effectuer nos choix les plus importants.")])]);

}]

export { render, staticRenderFns }